export default __webpack_public_path__ + "static/media/laundry1-beforeA-2048w.cc0dc8da.webp";